import * as L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import distance from '@turf/distance';
import nearestPointOnLine from '@turf/nearest-point-on-line';


export class MapController {
  constructor(track, fences, user_position) {
    this.track = track;
    this.fences = fences;

    let track_latlong = L.GeoJSON.coordsToLatLngs(this.track.coordinates);
    let fences_latlong = L.GeoJSON.coordsToLatLngs(this.fences);

    this.user = L.circle(user_position, {color: 'hsl(var(--p))'});
    this.path = L.polyline(track_latlong, {color: 'hsl(var(--a))'});
    this.points = fences_latlong.map(el => {
      return L.circle(el, {color: 'hsl(var(--af))'});
    });

    this.tiles = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      maxZoom: 20
    });
  }

  widget(node) {
    this.map = L.map(node);
    this.tiles.addTo(this.map);

    this.path.addTo(this.map);
    this.points.forEach(el => {
      el.addTo(this.map);
    });

    this.user.addTo(this.map);

    this.map.fitBounds(this.path.getBounds());

    var self = this

    return { destroy() { self.map.remove(); } };
  }

  is_widget_active() {
    return this.map && this.user;
  }

  set_user_position(latitude, longitude) {
    this.user.setLatLng([latitude, longitude]);
  }

  get_progress_from(latitude, longitude) {
    let closest = nearestPointOnLine(this.track, [longitude, latitude]);
    let percentage = (closest.properties.index / this.track.coordinates.length) * 100

    return closest.properties.dist > 1 ? 0 : percentage;
  }

  get_distance(user_lat, user_lon, point_lat, point_lon) {
    return distance([user_lon, user_lat], [point_lon, point_lat]);
  }
}
